import React from 'react';

interface AuthInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export function AuthInput({ label, ...props }: AuthInputProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/90 mb-1">
        {label}
      </label>
      <input
        {...props}
        className="w-full px-4 py-3 border border-white/20 rounded-xl bg-white/10 backdrop-blur-sm 
          focus:bg-white/20 transition-all duration-300 ease-in-out text-white
          focus:border-amber-300/50 focus:ring-2 focus:ring-amber-300/20
          placeholder:text-white/50"
      />
    </div>
  );
}